// @ts-strict-ignore
/** @jsx jsx */
import { jsx } from 'theme-ui'

import connectEntity from '../helpers/connect-entity'
import { GridFromJson, EVEntry } from '@uswitch/ev-core/react'
import { contentId } from '../../utils/contentful'

const ConnectedGrid = connectEntity((state, props) => ({
  json: props.layout,
}))(GridFromJson)

const Grid = ({ content, prependContent, layout, ...props }) => {
  const childrenArray = [prependContent]
    .concat(content.map((entity) => <EVEntry {...entity} key={contentId(entity)} />))
    .filter((i) => i)

  return <ConnectedGrid entity={layout} childrenArray={childrenArray} {...props} />
}

export default Grid
